import { Component, Input, Output, EventEmitter } from '@angular/core';
import { User, UserBiometricValidation, UserBiometricValidationStatusEnum } from '@app/models';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NotyService, UserService, VerificationService } from '@app/services';

@Component({
  selector: 'app-verification-warning',
  templateUrl: './verification-warning.component.html',
  styleUrls: ['./verification-warning.component.scss'],
  imports: [TranslatePipe],
  standalone: true
})
export class VerificationWarningComponent {
  @Input() currentUser: User;
  @Output() currentUserChange = new EventEmitter<User>();

  constructor(
    private verificationService: VerificationService,
    private userService: UserService,
    private notyService: NotyService,
    private translateService: TranslateService
  ) {}

  validateUserCreateDocument() {
    this.verificationService.validateUserCreateDocument().subscribe({
      next: (data: UserBiometricValidation) => {
        if (data?.status === UserBiometricValidationStatusEnum.Completed) {
          const updatedUser = { ...this.currentUser, biometric_required: false };
          this.currentUser = updatedUser;
          this.currentUserChange.emit(updatedUser);
          this.userService.getCurrentUser({ fetchPolicy: 'network-only' }).subscribe(); // Refresh the current user cache
          this.notyService.success(this.translateService.instant('notyService.validateUserBiometricSuccess'));
        }
      }
    });
  }
}
